import { jwtDecode } from 'jwt-decode';

import type { DecodedServerUserToken, ShortUserType } from '~/types';

const getCookie = (name: string): string | null => {
  if (typeof document === 'undefined') {
    return null;
  }

  const escapedName = name.replace(/[$()*+./?[\\\]^{|}-]/g, '\\$&');
  const match = document.cookie.match(new RegExp(`(?:^|; )${escapedName}=([^;]*)`));

  return match ? decodeURIComponent(match[1]) : null;
};

export const getClientUser = (): ShortUserType | null => {
  const idToken = getCookie('id_token');

  if (!idToken) {
    return null;
  }

  try {
    const { iat: _iat, exp: _exp, ...user } = jwtDecode<DecodedServerUserToken>(idToken);

    return user;
  } catch {
    return null;
  }
};
export const getReferralClientUser = (): ShortUserType | null => {
  const idToken = getCookie('clients_id_token');

  if (!idToken) {
    return null;
  }

  try {
    const { iat: _iat, exp: _exp, ...user } = jwtDecode<DecodedServerUserToken>(idToken);

    return user;
  } catch {
    return null;
  }
};
